export default __webpack_public_path__ + "static/media/banner-login.cdf6dca1.png";